/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NivelLinguaEnum = 1 | 2 | 3;

export const NivelLinguaEnum = {

    NUMBER_1: 1 as NivelLinguaEnum,

    NUMBER_2: 2 as NivelLinguaEnum,

    NUMBER_3: 3 as NivelLinguaEnum
};

